<template>
  <b-table-simple
    hover
    striped
    responsive
    class="rounded-bottom mb-0 mt-0"
  >
    <b-thead head-variant="light">
      <b-tr>
        <b-th>Product</b-th>
        <b-th>Sales [MYR]</b-th>
        <b-th>Cost [MYR]</b-th>
        <b-th>Total Txn</b-th>
        <b-th>Profit</b-th>
      </b-tr>
    </b-thead>
    <b-tbody>
      <template v-if="list.length>0">
        <b-tr
          v-for="(tr, indextr) in list"
          :key="indextr"
        >
          <b-td>
            {{ tr.operator_name }}
          </b-td>
          <b-td>
            {{ tr.transactions.org_amt }}
          </b-td>
          <b-td>
            {{ tr.transactions.amt }}
          </b-td>
          <b-td>
            {{ tr.transactions.tr_count }}
          </b-td>
          <b-td>
            {{ tr.transactions.profit }}
          </b-td>
        </b-tr>
      </template>
      <template v-else>
        <b-tr rowspan="10">
          <b-td
            colspan="5"
            class="text-center"
          >
            No data avilable
          </b-td>
        </b-tr>
      </template>
    </b-tbody>
  </b-table-simple>
</template>
<script>
import {
  BTableSimple,
  BThead,
  BTr,
  BTh,
  BTd,
  BTbody,
} from 'bootstrap-vue'

export default {
  components: {
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
  },
  props: ['data'],
  data() {
    return {
      operatorData: [],
    }
  },
  computed: {
    list() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.operatorData = []
      const self = this
      this.data.map(value => self.operatorData.push(value))
      return this.operatorData
    },
  },
}

</script>
